const emailRE =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

const mobileRE = /^[6-9]\d{9}$/;

export const VALIDATORS: Record<
  string,
  (value: string | number) => boolean | string
> = {
  EMAIL: (val: number | string) =>
    !val ? true : emailRE.test(String(val)) ? true : "Invalid email",
  MOBILE: (val: number | string) =>
    !val ? true : mobileRE.test(String(val)) ? true : "Invalid mobile number",
};
